export class JwtTokenClaimsConstants {
  public static CURRENT_USER: string = "currentUser";
  public static TOKEN: string = "token";
  public static USER_ID: string = "userId";
  public static AUTHORITIES: string = "authorities";
  public static USER_SID: string = "userSid";
  public static PROJECT_IDS: string = "projectIds";
}
